import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { renderItemSinglePath } from "../../Common/Function";
import { GetItem } from "./Components/Services";

const Redirec2 = () => {
  const navigate = useNavigate();

  useEffect(() => {
    Handler();
  }, []);
  const Handler = () => {
    navigate("/pool/shahrud/استخر-موج-شاهرود");
  };
  return <div></div>;
};

export default Redirec2;
